import React, { Fragment } from 'react';
import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';
import { NavLink } from 'reactstrap';
import Card from '../../../components/Card/Card';
import FlowListFilters from '../../../components/Flow/FlowListFilters';
import FlowsList from '../../../components/Flow/FlowsList';
import Layout from '../../../components/Layout/Layout';
import Pagination from '../../../components/Pagination/Pagination';
import DialogModal from '../../../modals/DialogModal/DialogModal';
import NewTitleModal from '../../../modals/NewTitleModal/NewTitleModal';
import { FMessage } from '../../../hoc/IntlComponents';

const View = ({
  data: {
    loading,
    page,
    search,
    sortOrder,
    sortBy,
    title,
    flows,
    pageCount,
    startSetStreams,
    showModal,
    showModalCopy,
    base,
  },
  handleSearch,
  updateLocation,
  changePage,
  handleFlowRemove,
  handleSort,
  toggleModal,
  toggleModalCopy,
  removeFlow,
  handleFlowCopy,
  copyFlow,
}) => {
  return (
    <Layout>
      <Layout.Col md="12">
        <Card.Header>
          <FMessage id="flows.header.title" />
        </Card.Header>
        <div className="streams-list-btn-wrapper">
          <NavLink className="active" to="/tools/flows/create" tag={Link}>
            <FormattedMessage id="flows.buttons.add-flow" defaultMessage="Add Flow" />
          </NavLink>
        </div>

        <Card className="streams-list card-loading-silent streams-list-wrapper" loading={loading}>
          <Card.Body>
            <FlowListFilters
              onSearch={handleSearch}
              query={title}
              onChange={startSetStreams}
              updateLocation={updateLocation}
            />

            {!loading && !search && pageCount > 1 && (
              <Pagination
                pageCount={pageCount}
                activePage={page + 1}
                onPageChange={changePage}
                scrollToAfterPageChanged={{ ref: null }}
              />
            )}

            {search && flows.length === 0 ? (
              <div className="card-empty">
                <FormattedMessage id="flows.not-found" defaultMessage="No flows found" />
              </div>
            ) : (
              <Fragment>
                {flows.length > 0 ? (
                  <FlowsList
                    flows={flows}
                    onFlowRemove={handleFlowRemove}
                    onFlowCopy={handleFlowCopy}
                    sortOrder={sortOrder}
                    sortBy={sortBy}
                    handleSort={handleSort}
                  />
                ) : (
                  <div className="card-empty">
                    <FormattedMessage id="flows.no-flows" defaultMessage="No flows" />
                  </div>
                )}
              </Fragment>
            )}
          </Card.Body>

          {!loading && !search && pageCount > 1 && (
            <Card.Footer>
              <Pagination
                pageCount={pageCount}
                activePage={page + 1}
                onPageChange={changePage}
                scrollToAfterPageChanged={{ ref: null }}
              />
            </Card.Footer>
          )}
        </Card>
      </Layout.Col>

      <FormattedMessage
        id="flows.modal.message"
        defaultMessage="Would you like to remove this flow?"
      >
        {(message) => (
          <DialogModal
            open={showModal}
            message={message}
            onCancel={toggleModal}
            onConfirm={removeFlow}
          />
        )}
      </FormattedMessage>
      <FormattedMessage id="flows.modal.copy.title" defaultMessage="New Title">
        {(header) => (
          <NewTitleModal
            header={header}
            open={showModalCopy}
            onCancel={toggleModalCopy}
            onConfirm={copyFlow}
            base={base}
          />
        )}
      </FormattedMessage>
    </Layout>
  );
};

export default View;
